// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SiteLeads_WebhookInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /site/v1/webhooks/leads — the envelope the
 * institutional site emits when a visitor submits a form.
 *
 * Only the ENVELOPE is validated: `event_id`, `tenant`, `formulario` and that
 * `data` is an object. What is INSIDE `data` is never checked here — the field
 * definition lives in the site's tenant pack, the site validates against it
 * before emitting, and a receiver that second-guessed that list would refuse
 * real leads the day a field is renamed.
 *
 * `event_id` is minted by the site and is the IDEMPOTENCY KEY — the site
 * retries a failed delivery with the SAME id, and the receiver must answer the
 * same lead twice without creating a second row.
 *
 * `unit_slug` is the one exception to "only the envelope": a unit-page form
 * says which unit it was sent from. The FRANCHISE is never taken from the
 * envelope — the slug comes from the visitor's browser, so this service looks
 * the unit up in site_unidades and uses the franchise recorded there (see
 * Site_webhooks::leads). A slug that matches no visible unit files the lead
 * with no unit rather than refusing it.
 *
 * Authentication is the HMAC signature, not this body (see
 * libraries/site/Site_webhook_verifier.php).
 */
import { registerContract } from './validate'

export interface SiteLeads_WebhookInput {
event_id?: string
event?: string
tenant?: string
formulario?: string
formulario_versao?: number
occurred_at?: string
data?: Record<string, unknown>
campanha?: Record<string, unknown>
unit_slug?: string
finalidade?: string
}

registerContract('SiteLeads_WebhookInput', {
  event_id:          { type: 'string',  required: false },
  event:             { type: 'string',  required: false },
  tenant:            { type: 'string',  required: false },
  formulario:        { type: 'string',  required: false },
  formulario_versao: { type: 'number',  required: false },
  occurred_at:       { type: 'string',  required: false },
  data:              { type: 'object',  required: false },
  campanha:          { type: 'object',  required: false },
  unit_slug:         { type: 'string',  required: false },
  finalidade:        { type: 'string',  required: false },
})
